import * as StorageService from "../services/StorageService";
import {activeOrderStatuses, LOCALSTORAGE_ITEMS} from "./Constants";
import {FormattedMessage, FormattedNumber, IntlProvider} from "react-intl";
import * as AccountService from "../services/AccountService";
import * as CampaignService from "../services/CampaignService";
import {EventBus} from "./EventBus";
import React from "react";
import {APP_VERSION} from "../config/ClientConfig";


export const removeUserInfoFromStorage = () => {
    StorageService.removeItem(LOCALSTORAGE_ITEMS.USER_INFO);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.USER_TYPE);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.USER_EMAIL);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.CONTINUE_AS_GUEST);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.RESERVATION_INFO);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.ORDER_ID);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.CARD_DETAILS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.PREVIOUS_TRANSACTION_ID);
    // StorageService.removeItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN);
    // StorageService.removeItem(LOCALSTORAGE_ITEMS.CURRENT_CART);
    // StorageService.removeItem(LOCALSTORAGE_ITEMS.PRODUCT_DETAILS);
}
export const getCookie = (name) => {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].split("=");
        if (cookie[0] === name) {
            return cookie[1];
        }
    }
    return "";
}


export const isInWebView = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return (window.ReactNativeWebView || /wv|WebView/i.test(userAgent));
}

export const detectBrowser = () => {
    const userAgent = navigator.userAgent;

    const browsers = [
        { name: "Chrome", regex: /Chrome\// },
        { name: "Safari", regex: /Safari\/.*Version\// },
        { name: "Samsung Browser", regex: /SamsungBrowser\// },
        { name: "Edge", regex: /Edg\// },
        { name: "Firefox", regex: /Firefox\// },
        { name: "Opera", regex: /OPR\// }
    ];


    const isSupported = browsers.some(browser => browser.regex.test(userAgent));


    const isBrave = userAgent.includes("Brave/") || (navigator.brave && navigator.brave.isBrave);

    const isIOSSafari = /iPhone|iPad|iPod/i.test(userAgent) && /Safari/i.test(userAgent) && !/Chrome/i.test(userAgent);

    let isStorageBlocked = false;
    try {
        localStorage.setItem('test', 'test');
        localStorage.removeItem('test');
    } catch (e) {
        isStorageBlocked = true;
    }


    let areCookiesBlocked = false;
    try {
        document.cookie = "testCookie=test; max-age=60; path=/";
        if (!document.cookie.includes("testCookie=test")) {
            areCookiesBlocked = true;
        }
        document.cookie = "testCookie=; max-age=0; path=/";
    } catch (e) {
        areCookiesBlocked = true;
    }

    if (isBrave) {
        console.log("Brave browser detected!");
    } else if (isStorageBlocked) {
        console.log("Storage (localStorage/sessionStorage) is blocked.");
    } else if (areCookiesBlocked) {
        console.log("Cookies are blocked.");
    } else if (!isSupported) {
        console.log("Some functionalities may not work with your current browser");
    } else {
        console.log("Supported browser detected");
    }


    if (!localStorage.getItem("UNSUPPORTED_BROWSER_ALERT_SHOWN") && (isBrave || isStorageBlocked || areCookiesBlocked) && !isIOSSafari) {
        let message = "Some functionalities may not work with your current browser due to privacy features like ad-blocking, storage blocking, or cookies blocking.";
        alert(message);


        localStorage.setItem("UNSUPPORTED_BROWSER_ALERT_SHOWN", "true");
    }
}





export const onUseAppInsteadOfWeb = () => {
    const shopName = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME);
    const userTable = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE);


    const navigateToApp = () => {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
            window.location.href = "https://play.google.com/store/apps/details?id=ro.gebs.zonizbeacon&referrer=utm_source%3Dzoniz%26utm_medium%3Dcpc%26utm_term%3D"+encodeURIComponent(shopName)+"%26utm_content%3D"+encodeURIComponent(userTable);
        }
        else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            window.location.href = 'https://apps.apple.com/ro/app/zoniz/id847332221';
        }else{
            window.location.href = 'https://www.zoniz.com/download';
        }
    }

    if(!StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID)) {
        AccountService.deleteAccount().then(r => {
            StorageService.removeItem(LOCALSTORAGE_ITEMS.USER_EMAIL);
            navigateToApp();
        });
    }else{
        navigateToApp();
    }
}

export const findMobileOperatingSystemAndGetLink = () => {
    const shopName = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME);
    const userTable = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE);
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
        return "https://play.google.com/store/apps/details?id=ro.gebs.zonizbeacon&referrer=utm_source%3Dzoniz%26utm_medium%3Dcpc%26utm_term%3D"+encodeURIComponent(shopName)+"%26utm_content%3D"+encodeURIComponent(userTable);
        // return "https://play.google.com/store/apps/details?id=ro.gebs.zonizbeacon";
    }
    else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "https://apps.apple.com/ro/app/zoniz/id847332221";
    }else{
        return "https://www.zoniz.com/download";
    }

}

export const findMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
        return "android";
    }
    else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "ios";
    }else{
        return "android"; // used for showing browser img @ Open in App banner
    }
}

export const getCategoryName = (category) => {

    const browserLocale = getAppLanguage(); // first two characeters from eg: en-US
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)):null;
    const shopLocale = shopDetails? shopDetails.lang:null;
    if(shopLocale===null){
        return
    }
    if (shopLocale != browserLocale) {
        const merchantConfig = shopDetails.merchantConfig;
        const categoryIndex = merchantConfig.productTags.findIndex(e => e == category);
        const categoriesInt = merchantConfig.productTags_int;
        if(categoriesInt && categoriesInt.length > categoryIndex && categoriesInt[categoryIndex] != null && categoriesInt[categoryIndex] != "") {
            return getShopTranslated(categoriesInt[categoryIndex]);
        }else return category;
    }else{
        return category;
    }
}

export const getProdName = (product) => {
    const browserLocale = getAppLanguage();
    const shopLocale = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).lang :null;

    const nameInt = product.name_int;
    if (nameInt && nameInt != null && nameInt!= "" && shopLocale != browserLocale) {
        return getProductTranslated(nameInt);
    }else{
        return product.name;
    }
}

export const getCampaignTitle = (campaign) => {
    const browserLocale = getAppLanguage();
    const shopDetails = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS));


    const shopLocale = shopDetails.lang;
    const hasTranslations = shopDetails.translated? shopDetails.translated[browserLocale] : null;

    const titleInt = campaign.vTitle_int;
    const title = campaign.vTitle ? campaign.vTitle:campaign.title;
    if (titleInt && titleInt !== null && titleInt !== "" && shopLocale !== browserLocale) {
        return hasTranslations ? title : titleInt;
    }else{
        return title;
    }
}


export const getExtraProductName = (extra) => {
    const browserLang = getAppLanguage(); // first two characeters from eg: en-US
    const shopLocale = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).lang

    const nameInt = extra.name_int;
    if (nameInt && nameInt != null && nameInt !== "" && shopLocale !== browserLang) {
        return getExtraTranslated(nameInt);
    }else{
        return extra.name;
    }
}

export const getOrderCheckoutMsg = () => {
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const browserLocale = getAppLanguage(); // first two characeters from eg: en-US
    const shopLocale = shopDetails? shopDetails.lang:null;

    const orderCheckoutMsg_int = shopDetails.merchantConfig.orderCheckoutMsg_int;
    const orderCheckoutMsg = shopDetails.merchantConfig.orderCheckoutMsg;

    let finalCheckoutMsg;

    if (orderCheckoutMsg_int && orderCheckoutMsg_int != null && orderCheckoutMsg_int != "" && shopLocale != browserLocale) {
        finalCheckoutMsg = getShopTranslated(orderCheckoutMsg_int);
    } else {
        finalCheckoutMsg = orderCheckoutMsg || <FormattedMessage id="TheWaiterWillBringYouTheCheckShort"/>;
    }
    return finalCheckoutMsg;
}

export const getProdDesc = (product) => {

    const browserLang = getAppLanguage(); // first two characeters from eg: en-US
    const shopLocale = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).lang

    const descInt = product.desc_int;

    let finalProductDesc;

    if (descInt && descInt != null && descInt !== "" && shopLocale !== browserLang) {
        finalProductDesc = getProductTranslated(descInt);
    } else {
        finalProductDesc = product.desc;
    }


    finalProductDesc = finalProductDesc.replaceAll("<", "&lt;");
    finalProductDesc = finalProductDesc.replaceAll(">", "&gt;");
    const index1 = finalProductDesc.indexOf("[link=\"");
    if (index1 >= 0) {
        const index2 = finalProductDesc.indexOf("\"", index1 + "[link=\"".length);
        if(index2 > 0) {
            const link = finalProductDesc.substring(index1 + "[link=\"".length, index2);
            if(link.startsWith("http")){
                const index3 = finalProductDesc.indexOf("text=\"", index2 + 1);
                if (index3 >= 0) {
                    const index4 = finalProductDesc.indexOf("\"", index3 + "text=\"".length);
                    if (index4 >= 0) {
                        const text = finalProductDesc.substring(index3 + "text=\"".length, index4);
                        const index5 = finalProductDesc.indexOf("]", index4);
                        finalProductDesc = finalProductDesc.substring(0, index1) + "<br/><a href='" + link + "'>" + text + "</a></br>" + finalProductDesc.substring(index5 + 1);
                    }
                }
            }
        }
    }

    return finalProductDesc;

}

export const getProdOptions = (product, index) => {
    const browserLang = getAppLanguage(); // first two characeters from eg: en-US
    const shopLocale = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).lang

    const optionsInt = product.options_int;
    if (optionsInt && optionsInt != null && optionsInt.length > index && optionsInt[index] !== "" && shopLocale !== browserLang) {
        return getProductTranslated(optionsInt[index]);
    }else{
        return product.options[index];
    }
}


export const getProdOptionsFromCart = (choice) => {
    const browserLocale = getAppLanguage(); // first two characeters from eg: en-US
    const shopLocale = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).lang : null;

    const optionInt = choice.option_int;
    if (optionInt && optionInt != null && optionInt!= "" && shopLocale != browserLocale) {
        return getProductTranslated(optionInt);
    }else{
        return choice.option;
    }
}



export const getProdExtrasFromCart = (choice, extraPidNotAvailable) => {
    const browserLocale = getAppLanguage(); // first two characeters from eg: en-US
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const shopLocale = shopDetails? shopDetails.lang : null;
    const currency = shopDetails ? shopDetails.currency : null;

    const extrasNames = [];
    const priceLocale = getAppLocale();
    if(choice.extras && choice.extras.length > 0) {
        const sortedExtras = [...choice.extras].sort((a, b) => (b.isReqExtra || b.req ? 1 : 0) - (a.isReqExtra || a.req? 1 : 0));
        sortedExtras.forEach(extra => {
            const extraInt = extra.name_int;
            let finalName = "";
            if (extraInt && extraInt != null && extraInt != "" && shopLocale != browserLocale) {
                finalName = getExtraTranslated(extraInt);
            } else {
                finalName = extra.name
            }
            extrasNames.push(
                <div key={extra.pid} className={extraPidNotAvailable && extraPidNotAvailable.includes(extra.pid)? "row danger" : "row"}>{extra.isReqExtra || extra.req ? <FormattedMessage id="Includes"/> : <FormattedMessage id="Extra"/>}: &nbsp;
                    {finalName}&nbsp;
                    <span className="prod-price">
                <IntlProvider
                    locale={priceLocale}>
                    <FormattedNumber
                        value={
                            extra.price / 100.0}
                        style="currency"
                        minimumFractionDigits={2}
                        maximumFractionDigits={2}
                        currency={currency}/>
                </IntlProvider>

                </span>
                </div>);
        });
    }

    return extrasNames;
}
export const getTotalProducts = (orderDetails) => {
    let totalProducts = 0;

    orderDetails?.forEach(product => {
        if (product.status !== "CANCELED") {
            totalProducts+=product.quantity;
        }else{
            totalProducts-=product.quantity;
        }
    })
    return totalProducts;
}

export const calculatePercentage = (partialValue, totalValue, numOfDigits) => {
    const discount = (100 * partialValue) / totalValue;
    return (Math.round(discount * 100) / 100).toFixed(numOfDigits);
}

export const findReturnable = (products) => {
    for (const product of products) {
        if(product.extras){
            for (const extra of product.extras) {
                if (extra.returnable) {
                    return true;
                }
            }
        }
    }
    return false;
}
export const calculatePercentageDiscount = (allOrderProducts) => {
    
    if(allOrderProducts.discount == 0) return 0;
    
    const basePrice = calculateSubtotalPrice(allOrderProducts);

    const products = allOrderProducts.products;
    let returnableTotalValue = 0;

    for (const product of products) {
        if(product.extras){
            for (const extra of product.extras) {
                if (extra.returnable) {
                    returnableTotalValue += extra.price;
                }
            }
        }
    }
    return Math.round(allOrderProducts.discount / (basePrice  - returnableTotalValue) * 100);
}

export const calculateSubtotalPrice = (allOrderProducts, withDiscount, withTips, withDeliveryFee) => {
    const orderPrice = allOrderProducts.price;
    const discount = allOrderProducts.discount?allOrderProducts.discount:0;
    const tips = allOrderProducts.tips?allOrderProducts.tips:0;
    const deliveryFee = allOrderProducts.deliveryFee?allOrderProducts.deliveryFee:0;

    let basePrice = orderPrice + (withDiscount?0:discount) - (withTips?0:tips) - (withDeliveryFee?0:deliveryFee);

    return basePrice;
}

export const renderProducts = (allOrderProducts) => {
    const currency = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).currency:null;
    const finalProductsArray = [];

    for (let i = 0; i < allOrderProducts?.products.length; i++) {
        let found = false;
        for (let j = 0; j < finalProductsArray.length; j++) {
            if (allOrderProducts?.products[i].pid === finalProductsArray[j].pid &&
                allOrderProducts?.products[i].status === finalProductsArray[j].status &&
                allOrderProducts?.products[i].option === finalProductsArray[j].option &&
                allOrderProducts?.products[i].msg === finalProductsArray[j].msg
            ) {
                finalProductsArray[j].quantity += allOrderProducts?.products[i].quantity
                found = true;
                break;
            }
        }
        if (!found) {
            finalProductsArray.push({
                ...allOrderProducts.products[i]
            })
        }
    }

    const renderResult = [];
    const renderProduct = (product, productIndex) =>
        <div key={productIndex} className="product">
            <div className="row">
                <span className="prod-qty">{product.quantity}<span className="times">&times;</span></span>
                <span className="prod-name">{getProdName(product)}</span>
                <span className="prod-price">&nbsp;
                    <IntlProvider locale={getAppLocale()}>
                        <FormattedNumber
                            value={product.price / 100}
                            style="currency"
                            minimumFractionDigits={2}
                            maximumFractionDigits={2}
                            currency={currency} />
                    </IntlProvider>
                </span>
            </div>
            <div className="choices row">
                {product.option?
                    <span>
                        {getProdOptionsFromCart(product)}
                        &nbsp;</span>
                    :null
                }
                {product.msg?
                    <span>{product.msg}&nbsp;</span>
                    :null
                }
            </div>
            <div className="choices row">
                {product.extras?
                    <>
                        {getProdExtrasFromCart(product)}
                    </>
                    :null
                }
            </div>
        </div>;
    const renderCanceledProduct = (product, productIndex) =>
        <div key={productIndex} className="product canceled">
            <div className="row">
                <div className="prod-name-and-qty">
                    <span className="prod-qty">{product.quantity}<span className="times">&times;</span></span>
                    <span className="prod-name">{getProdName(product)}</span>
                </div>
                <span className="prod-price">
                    <IntlProvider locale={getAppLocale()}>
                        <FormattedNumber
                            value={product.price / 100}
                            style="currency"
                            minimumFractionDigits={2}
                            maximumFractionDigits={2}
                            currency={currency} />
                    </IntlProvider>
                </span>
            </div>
            <div className="choices row">
                {product.option?
                    <span>
                        {getProdOptionsFromCart(product)}
                        &nbsp;</span>
                    :null
                }
                {product.msg?
                    <span>{product.msg}&nbsp;</span>
                    :null
                }
                <div className="choices row">
                    {product.extras?
                        <>
                            {getProdExtrasFromCart(product)}
                        </>
                        :null
                    }
                </div>
            </div>
        </div>;

    for (var i = 0; i < finalProductsArray.length; i++) {
        const finalProduct_i = finalProductsArray[i];
        if (finalProduct_i.status === "CANCELED") {

        } else if (finalProduct_i.status === "READY") {
        } else {
            for (var j = 0; j < finalProductsArray.length; j++) {
                if (finalProduct_i.pid === finalProductsArray[j].pid &&
                    finalProductsArray[j].status === "CANCELED" &&
                    finalProduct_i.option === finalProductsArray[j].option &&
                    finalProduct_i.msg === finalProductsArray[j].msg
                ) {
                    finalProduct_i.quantity -= finalProductsArray[j].quantity;
                }
            }
        }

        if (finalProduct_i.quantity > 0){
            if(finalProduct_i.status === "CANCELED") {
                renderResult.push(renderCanceledProduct(finalProduct_i, i));
            } else {
                renderResult.push(renderProduct(finalProduct_i, i));
            }
        }
    }

    return renderResult;
}



export const handleScrollPosition = () => {
    const scrollPosition = StorageService.getItem(LOCALSTORAGE_ITEMS.SCROLL_POSITION);
    if (scrollPosition) {
        setTimeout(() => {
            window.scrollTo({ top: scrollPosition, left: 0});
            StorageService.removeItem(LOCALSTORAGE_ITEMS.SCROLL_POSITION);
        }, 100);
    }
};
const isTimeIntervalOpen = (startOrder, endOrder, ti) => {
    const currentTime = toMinutes(new Date().getHours() + ":" + new Date().getMinutes());
    const openingTime = toMinutes(ti.openFrom, - startOrder);
    const closingTime = toMinutes(ti.openUntil, - endOrder);
    if (compareMinutes(closingTime, openingTime) === 1) {
        return (compareMinutes(openingTime, currentTime) === -1 || compareMinutes(openingTime, currentTime) === 0) &&
            (compareMinutes(closingTime, currentTime) === 1 || compareMinutes(closingTime, currentTime) === 0);
    }else if (compareMinutes(closingTime, openingTime) === -1) {
        return !(compareMinutes(openingTime, currentTime) === 1 && compareMinutes(closingTime, currentTime) === -1);
    }else {
        return true;
    }
};

const isTimeIntervalOpenForReservation = (ti) => {
    const currentTime = toMinutes(new Date().getHours() + ":" + new Date().getMinutes());
    const openingTime = toMinutes(ti.openFrom);
    const closingTime = toMinutes(ti.openUntil);

    if (compareMinutes(closingTime, openingTime) === 1) {
        return (compareMinutes(openingTime, currentTime) <= 0 && compareMinutes(closingTime, currentTime) >= 0);
    } else if (compareMinutes(closingTime, openingTime) === -1) {
        return !(compareMinutes(openingTime, currentTime) === 1 && compareMinutes(closingTime, currentTime) === -1);
    } else {
        return true;
    }
};

const isDayOfWeekScheduleOpenForReservation = (daySchedule) => {
    if (daySchedule?.isOpen) {
        if (daySchedule.daySchedule?.length) {
            return daySchedule.daySchedule.some(timeSlot => isTimeIntervalOpenForReservation(timeSlot));
        }
        return isTimeIntervalOpenForReservation({ openFrom: daySchedule.openFrom, openUntil: daySchedule.openUntil });
    }
    return false;
};

export const isReservationOpen = () => {
    const shopDetails = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS));

    if (!shopDetails?.merchantConfig?.weekReservationSchedule?.schedule ||
        shopDetails.merchantConfig.weekReservationSchedule.schedule.length === 0) {
        return false;
    }

    const dayOfWeek = new Date().getDay() === 0 ? 6 : new Date().getDay() - 1;
    const daySchedule = shopDetails.merchantConfig.weekReservationSchedule.schedule[dayOfWeek];

    return isDayOfWeekScheduleOpenForReservation(daySchedule);
};

const isDayOfWeekScheduleOpen = (dayOfWeekSchedule, startOrder, endOrder) => {
    if(dayOfWeekSchedule){
        if(dayOfWeekSchedule.isOpen) {
            if(dayOfWeekSchedule.daySchedule) {
                for (let i = 0; i < dayOfWeekSchedule.daySchedule.length; i++) {
                    if (isTimeIntervalOpen(startOrder,endOrder,dayOfWeekSchedule.daySchedule[i])) {
                        return true;
                    }
                }
                return false;
            }else {
                return isTimeIntervalOpen(startOrder,
                    endOrder,
                    {
                        openFrom: dayOfWeekSchedule.openFrom,
                        openUntil: dayOfWeekSchedule.openUntil
                    });
            }
        }else {
            return false;
        }
    }
    return false;
}

export const isShopOpen = () => {

    const shopDetails = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS));

    if (! !!shopDetails.merchantConfig.weekOpenSchedule ||
        ! !!shopDetails.merchantConfig.weekOpenSchedule.shopOpenSchedule ||
        ! !!shopDetails.merchantConfig.weekOpenSchedule.schedule ||
        shopDetails.merchantConfig.weekOpenSchedule.schedule.length === 0

    ) {
        return false;
    }

    const dayOfWeek = new Date().getDay() === 0 ? 6: new Date().getDay() -1; // because in Javascript Sunday is 0 and in the array from weekOpenSchedule Sunday is 6

    const dayOfWeekSchedule = shopDetails.merchantConfig.weekOpenSchedule?.schedule[dayOfWeek];
    return isDayOfWeekScheduleOpen(dayOfWeekSchedule,
        shopDetails.merchantConfig.weekOpenSchedule?.startOrder,
        shopDetails.merchantConfig.weekOpenSchedule?.endOrder);
}

export const isDeliveryOpen = () => {

    const shopDetails = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS));

    if (! !!shopDetails?.merchantConfig.weekDeliverySchedule ||
        ! !!shopDetails?.merchantConfig.weekDeliverySchedule.schedule ||
        shopDetails?.merchantConfig.weekDeliverySchedule.schedule.length === 0
    ) {
        return false;
    }

    const dayOfWeek = new Date().getDay() === 0 ? 6: new Date().getDay() -1; // because in Javascript Sunday is 0 and in the array from weekOpenSchedule Sunday is 6

    const dayOfWeekSchedule = shopDetails.merchantConfig.weekDeliverySchedule?.schedule[dayOfWeek];
    return isDayOfWeekScheduleOpen(dayOfWeekSchedule,
        shopDetails.merchantConfig.weekOpenSchedule?.startOrder,
        shopDetails.merchantConfig.weekOpenSchedule?.endOrder);
}

const toMinutes = (time, addedMinutes) => {

    let hoursMin = parseInt(time.substring(0,2))*60;
    if(addedMinutes) hoursMin = hoursMin + addedMinutes;
    let minutes = parseInt(time.substring(3,5));
    return hoursMin + minutes;
}


export const getMinAndSecondsFromSeconds = (givenSeconds) => {

    const minutes = Math.floor(givenSeconds / 60)
    const seconds = givenSeconds - minutes * 60;

    let ms = minutes;
    if(minutes < 10){
        ms = "0"+minutes;
    }

    let ss = seconds;
    if(seconds < 10){
        ss = "0"+seconds;
    }

    return (ms + ":" + ss);
}

const compareMinutes = (t1, t2) => {
    if(t1 == t2){
        return 0;
    }else if(t1 < t2){
        return -1;
    }else {
        return 1;
    }
}

export const addMinutes = (date, minutes) => {
    return new Date(date.getTime() + minutes*60000);
}

export const resetTime = (day) => {
    day.setHours(0);
    day.setMinutes(0);
    day.setSeconds(0);
    day.setMilliseconds(0);

    return day;
}


export const getLastTwelveMonths = () => {
    let d = new Date();
    d.setMonth(d.getMonth() - 12);
    return d;
}

export const getLastDay = () => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    return yesterday;
}

export const clearStorageItems = () => {
    StorageService.removeItem(LOCALSTORAGE_ITEMS.SUBORDERS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.ORDER_ID);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.GROUP_ORDER_ID);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.ALL_TAGS_AND_PRODUCTS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.PRODUCT_DETAILS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.CURRENT_CART);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.LOYALTY_PRODUCTS_POINTS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.ALL_CAMPAIGNS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.CALL_TS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.SHOP_NAME);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.USER_TABLE);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.PAYMENT_METHOD);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.ORDER_PLACE);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.PLAY_SOUND);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.SHOP_DICTIONARY);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.PRODUCTS_DICTIONARY);
    StorageService.removeItem(LOCALSTORAGE_ITEMS.EXTRAS_DICTIONARY);
    StorageService.removeItem("loginInfo"); //folosit in template-uri, in controllere

}

export const CAMPAIGNS_CACHE_TIMEOUT = 30 * 60 * 1000 // 30 minute 30*60*1000
export const PRODUCTS_CACHE_TIMEOUT = 5 * 60 * 1000 // 30 minute 30*60*1000
export const SHOP_DETAILS_CACHE_TIMEOUT = 30 * 60 * 1000 // 30 minute 30*60*1000

export const getAllCampaigns= async (shopName) => {
    const ts = StorageService.getItem(LOCALSTORAGE_ITEMS.CALL_TS);
    if (ts && new Date().getTime() - ts > CAMPAIGNS_CACHE_TIMEOUT) {
        StorageService.removeItem(LOCALSTORAGE_ITEMS.ALL_CAMPAIGNS);
    }

    if (StorageService.getItem(LOCALSTORAGE_ITEMS.ALL_CAMPAIGNS)) {
        return JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.ALL_CAMPAIGNS));
    }else{
        const allCampaignsResponse = await CampaignService.getAllCampaigns(shopName);
        if (allCampaignsResponse.ok) {
            const allCampaigns = allCampaignsResponse?.data;
            const correctOrderOnPage = ["products", "takeaway", "reservation"];
            let orderedAllCampaigns =[];


            const menuCampaigns = {};

            for(let j = 0; j < correctOrderOnPage.length; j++){
                menuCampaigns[correctOrderOnPage[j]] = [];
            }

            for(let i = 0; i < allCampaigns.length; i++){
                const campaign = allCampaigns[i];
                let menuFound = false;
                if(campaign.link && campaign.link.url){
                    for(let j=0;j < correctOrderOnPage.length;j++){
                        if(campaign.link.url.includes(correctOrderOnPage[j])){
                            menuCampaigns[correctOrderOnPage[j]].push(campaign);
                            menuFound = true;
                            break;
                        }
                    }
                }
                if(!menuFound){
                    orderedAllCampaigns.push(campaign);
                }
            }

            for(let j = correctOrderOnPage.length-1; j >= 0; j--){
                orderedAllCampaigns = menuCampaigns[correctOrderOnPage[j]].concat(orderedAllCampaigns);
            }

            if (orderedAllCampaigns) {
                StorageService.setItem(LOCALSTORAGE_ITEMS.ALL_CAMPAIGNS, JSON.stringify(orderedAllCampaigns));
                StorageService.setItem(LOCALSTORAGE_ITEMS.CALL_TS, new Date().getTime());
            }
            return allCampaigns;
        } else {
            EventBus.dispatch("genericErrorMsg");
            console.log("Error retrieving all campaigns");
            return [];
        }
    }
}

export function getAppLanguage() {
    const locale = getAppLocale();
    return locale.slice(0, 2);
}
export function getAppLocale() {
    // first two characeters from eg: en-US
    const paramLang = new URLSearchParams(window.location.search).get("lang")
    let locale = null;
    if(paramLang){
        locale = paramLang;
    }else {
        locale = (navigator.languages && navigator.languages[0]) ||
        navigator.language ||
        navigator.userLanguage;
    }
    return locale;
}

export function roundHalfEven(v) {
    return Math.round(v)&~(v*v%1==.25);
}

export const getProductInfoByPid = (data, pid) => {

    for (const category of data) {
        for (const product of category.products) {

            if (product.pid === pid) {

                return {
                    ...product,
                    extras: "x"
                };
            }
        }
    }
    return null;
}
export const getProductsOrderFromCart = (currentCart) => {
    if (! !!currentCart) {
        return;
    }
    return Object.keys(currentCart).flatMap((category, index) => {
        const categoryObject = currentCart[category];
        return Object.keys(categoryObject).flatMap((prodName, index) => {
            const product = categoryObject[prodName];
            return {
                ...product,
                category: category
            };
        });
    })
}

export const handleAppVersionUpdate = () => {
    if (StorageService.getItem(LOCALSTORAGE_ITEMS.APP_VERSION) !== APP_VERSION) {
        StorageService.setItem(LOCALSTORAGE_ITEMS.APP_VERSION, APP_VERSION);
        clearStorageItems();
    }
}

export const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

export const getLatestActiveOrder = (allOrders) => {
    let latestActiveOrder = null;

    for (let i = 0; i < allOrders.length; i++) {
        if (activeOrderStatuses.includes(allOrders[i].procStatus) && (latestActiveOrder === null || new Date(allOrders[i].created) > new Date(latestActiveOrder.created))) {
            if (allOrders[i].place !== "TAKE_AWAY" && allOrders[i].place !== "BAR") {
                latestActiveOrder = allOrders[i];
            }
        }
    }

    return latestActiveOrder;
};
export const storeRouteInParentPage = (route) => {
    window.parent.postMessage({
        type: 'CURRENT_ROUTE',
        route: route
    }, '*');
}

export const sendEvent = (event) => {
    window.parent.postMessage(event, '*');
}


export const refreshOnTabChange = () => {
    let shopName = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME);
    const onFocus = () => {
        if (shopName != StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME)) {
            console.log("RELOADING...");
            window.location.reload();
        }
    };
    window.addEventListener("focus", onFocus);
};

export const refreshOnTabChange2 =  () => {
    let shopName = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME);
    let hidden = null;
    let visibilityChange = null;
    if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
        hidden = 'hidden';
        visibilityChange = 'visibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
        hidden = 'msHidden';
        visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
        hidden = 'webkitHidden';
        visibilityChange = 'webkitvisibilitychange';
    }

    const handleVisibilityChange = () => {
        if (! !!document[hidden]) {
            if (shopName != StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME)) {
                console.log("Tab reload");
                window.location.reload();
                document.removeEventListener(visibilityChange, handleVisibilityChange);
            };
        }
    }

    document.addEventListener(visibilityChange, handleVisibilityChange);
};

let SHOP_DICTIONARY = null;
let PRODUCTS_DICTIONARY = null;
let EXTRAS_DICTIONARY = null;


export const addProductsToDictionary = (products, lang) => {
    if(!lang){
        lang = getAppLanguage();
    }
    StorageService.removeItem(LOCALSTORAGE_ITEMS.PRODUCTS_DICTIONARY);
    PRODUCTS_DICTIONARY = {};
    products.forEach((p) => {    
        if(p.translated && p.translated[lang]){
            if(p.name_int && p.name_int.length > 0){
                PRODUCTS_DICTIONARY[p.name_int] = p.translated[lang]["name"];
            }
            if(p.desc_int && p.desc_int.length > 0){
                PRODUCTS_DICTIONARY[p.desc_int] = p.translated[lang]["desc"];
            }
            if(p.options_int && p.options_int.length > 0 && 
                p.translated[lang].options && 
                p.translated[lang].options.length === p.options_int.length ){
                p.options_int.forEach((o,i) => {
                    PRODUCTS_DICTIONARY[o] = p.translated[lang].options[i];
                });            
            }           
        }    
    });

    StorageService.setItem(LOCALSTORAGE_ITEMS.PRODUCTS_DICTIONARY, JSON.stringify(PRODUCTS_DICTIONARY));
    StorageService.setItem(LOCALSTORAGE_ITEMS.LOCALE, getAppLocale());
};

export const addExtrasToDictionary = (extras, lang) => {
    if(!lang){
        lang = getAppLanguage();
    }

    StorageService.removeItem(LOCALSTORAGE_ITEMS.EXTRAS_DICTIONARY);
    EXTRAS_DICTIONARY = {};
    extras.forEach((p) => {    
        if(p.translated && p.translated[lang]){
            if(p.name_int && p.name_int.length > 0){
                EXTRAS_DICTIONARY[p.name_int] = p.translated[lang]["name"];
            }
        }    
    });

    StorageService.setItem(LOCALSTORAGE_ITEMS.EXTRAS_DICTIONARY, JSON.stringify(EXTRAS_DICTIONARY));
    StorageService.setItem(LOCALSTORAGE_ITEMS.LOCALE, getAppLocale());
};

export const addShopToDictionary = (shop, lang) => {
    if(!lang){
        lang = getAppLanguage();
    }

    StorageService.removeItem(LOCALSTORAGE_ITEMS.SHOP_DICTIONARY);
    SHOP_DICTIONARY = {};
    if(shop.translated && shop.translated[lang]){
        if(shop.tags_int && shop.tags_int.length > 0 && 
            shop.translated[lang].tags && 
            shop.translated[lang].tags.length === shop.tags_int.length){
            shop.tags_int.forEach((t,i) => {
                SHOP_DICTIONARY[t] = shop.translated[lang].tags[i];
            });            
        }

        if(shop.tags2_int && shop.tags2_int.length > 0 && 
            shop.translated[lang].tags2 && 
            shop.translated[lang].tags2.length === shop.tags2_int.length){
            shop.tags2_int.forEach((t,i) => {
                SHOP_DICTIONARY[t] = shop.translated[lang].tags2[i];
            });            
        }
        if(shop.merchantConfig && shop.merchantConfig.productTags_int && 
            shop.merchantConfig.productTags_int.length > 0 && 
            shop.translated[lang]["merchantConfig.productTags"] && 
            shop.translated[lang]["merchantConfig.productTags"].length === shop.merchantConfig.productTags_int.length){
            shop.merchantConfig.productTags_int.forEach((t,i) => {
                SHOP_DICTIONARY[t] = shop.translated[lang]["merchantConfig.productTags"][i];
            });            
        }

        if(shop.merchantConfig && shop.merchantConfig.productSubTags_int && 
            shop.merchantConfig.productSubTags_int.length > 0 && 
            shop.translated[lang]["merchantConfig.productSubTags"] && 
            shop.translated[lang]["merchantConfig.productSubTags"].length === shop.merchantConfig.productSubTags_int.length){
            shop.merchantConfig.productSubTags_int.forEach((t,i) => {
                SHOP_DICTIONARY[t] = shop.translated[lang]["merchantConfig.productSubTags"][i];
            });            
        }

        if(shop.merchantConfig && shop.merchantConfig.orderCheckoutMsg_int && 
            shop.merchantConfig.orderCheckoutMsg_int.length > 0 && 
            shop.translated[lang]["merchantConfig.orderCheckoutMsg"]){
            SHOP_DICTIONARY[shop.merchantConfig.orderCheckoutMsg_int] = shop.translated[lang]["merchantConfig.orderCheckoutMsg"];
        }
    }   
    StorageService.setItem(LOCALSTORAGE_ITEMS.SHOP_DICTIONARY, JSON.stringify(SHOP_DICTIONARY));
    StorageService.setItem(LOCALSTORAGE_ITEMS.LOCALE, getAppLocale());
};



export const getShopTranslated = (text) => {
    if(SHOP_DICTIONARY === null){
        if(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DICTIONARY)){
            SHOP_DICTIONARY = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DICTIONARY));
        }
    }

    if(SHOP_DICTIONARY !== null){
        const translated = SHOP_DICTIONARY[text];
        if(translated){
            return translated;
        }else {
            return text;
        }
    }else {
        return text;
    } 
};


export const getProductTranslated = (text) => {
    if(PRODUCTS_DICTIONARY === null){
        if(StorageService.getItem(LOCALSTORAGE_ITEMS.PRODUCTS_DICTIONARY)){
            PRODUCTS_DICTIONARY = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.PRODUCTS_DICTIONARY));
        }
    }

    if(PRODUCTS_DICTIONARY !== null){
        const translated = PRODUCTS_DICTIONARY[text];
        if(translated){
            return translated;
        }else {
            return text;
        }
    }else {
        return text;
    }
};

export const getExtraTranslated = (text) => {

    if(EXTRAS_DICTIONARY === null){
        if(StorageService.getItem(LOCALSTORAGE_ITEMS.EXTRAS_DICTIONARY)){
            EXTRAS_DICTIONARY = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.EXTRAS_DICTIONARY));
        }
    }

    if(EXTRAS_DICTIONARY !== null){
        const translated = EXTRAS_DICTIONARY[text];
        if(translated){
            return translated;
        }else {
            return text;
        }
    }else {
        return text;
    }
};
